import styled from "styled-components";
import { Card, Typography, Input, Icon, Modal } from "@plum-xoxo/admin-dsm";
import { getContentWrapperHeight } from "../../../../utils/header";

export const StyledBorderVertical = styled.div`
  border-right: 1px solid ${(props) => props.theme.palette.light.c300};
`;
export const StyledBorderHorizontal = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.palette.light.c300};
`;

export const StyledTypography = styled(Typography.H1).attrs()`
  color: ${(props) => props.theme.palette.dark.c300};
`;

export const SubtitleTypography = styled(Typography).attrs()`
  color: ${(props) => props.theme.palette.dark.c200};
`;

export const WalletBackground = styled(Typography).attrs()`
  background-color: ${(props) => props.theme.palette.light.c100};
  padding: 8px;
  border-radius: 40px;
  margin-bottom: 0px;
  margin-right: 24px;
`;

export const CardTitleTypography = styled(Typography.H3).attrs()`
  color: ${(props) => props.theme.palette.dark.c600};
`;
export const CardSubTitleTypography = styled(Typography.BodySemiBold).attrs()`
  color: ${(props) => props.theme.palette.dark.c200};
  margin: 0px;
`;
export const CardContentTypography = styled(Typography).attrs()`
  color: ${(props) => props.theme.palette.dark.c300};
  margin: 0px;
`;

export const VerifiedTextTypography = styled(Typography.BodySemiBold).attrs()`
  color: ${(props) => props.theme.palette.green.c200};
  margin: 0px;
`;

export const EditInfoInput = styled(Input).attrs()`
  border-color: ${(props) => props.theme.palette.dark.c600};
  width: "100%";
`;

export const AdditionTitleTextTypography = styled(Typography.BodySmall).attrs()`
  font-weight: ${(props) => {
    props.theme.typography.fontWeightMedium;
  }};
  color: ${(props) => props.theme.palette.dark.c300};
`;

export const UploadImageDiv = styled(Typography).attrs()`
  background-color: ${(props) => props.theme.palette.light.c100};
  padding: 20px !important;
  min-width: 320px;
`;

export const RewardTitleTextTypography = styled(Typography.H2).attrs()`
  font-weight: ${(props) => props.theme.typography.fontWeightBold};
  color: ${(props) => props.theme.palette.dark.c300};
`;

export const RewardActivetedTextTypography = styled(Typography).attrs()`
  color: ${(props) => {
    props.theme.palette.green.c300;
  }};
  background-color: ${(props) => props.theme.palette.green.c000};
  padding: 8px;
  border-radius: ${(props) => props.theme.borderRadius.tertiary}px;
`;

export const PreferenceCard = styled(Card).attrs()`
  .eui-tab-nav {
    padding: 40px 0px 0 40px;
    min-width: 220px;
    > div {
      border-right: 0px;
    }
  }
  .eui-tab-content {
    background-color: ${(props) => props.theme.palette.light.c100};
    padding: 32px 40px !important;
    height: calc(100vh - ${(props) => getContentWrapperHeight(props)});
    overflow: auto;
  }
`;

export const AmazonLogoTypography = styled(Typography).attrs()`
  padding: 5px;
  border-radius: ${(props) => props.theme.borderRadius.primary}px;
  border: 1px solid ${(props) => props.theme.palette.light.c100};
`;

export const ModalPhoneTextTypography = styled(Typography).attrs()`
  font-weight: ${(props) => props.theme.typography.semibold};
  color: ${(props) => props.theme.palette.dark.c200};
  margin: 2px;
`;

export const ModalBodyTextTypography = styled(Typography).attrs()`
  font-size: 12px;
  line-height: 16px;
  margin: 2px;
`;

export const EnterOTPTextTypography = styled(Typography).attrs()`
  font-size: 12px;
  line-height: 16px;
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  margin: 2px;
`;

export const BodyTextLightTypography = styled(Typography).attrs()`
  font-size: 12px;
  line-height: 16px;
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  margin: 2px;
  width: 153px;
  font-weight: 500;
  margin-right: 26px;
  color: ${(props) => props.theme.palette.dark.c300};
`;

export const ResendOtpText = styled(Typography).attrs()`
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.palette.dark.c200};
`;
export const StyledModal = styled(Modal).attrs()`
  width: 476px;
`;

export const NewGeneratedTokenBackground = styled(Typography).attrs()`
  background-color: ${(props) => props.theme.palette.light.c100};
  padding: 24px;
  max-height: 308px;
  overflow: auto;
`;

export const NewGeneratedTokenLoadingBackground = styled(Typography).attrs()`
  background-color: ${(props) => props.theme.palette.common.white};
  padding: 24px;
`;
// .eui-loader-center {
//   top: 40px;
// }
export const CustomCard = styled(Card).attrs()`
  box-shadow: ${(props) => props.theme.shadows["10"]};
`;

export const NewCustomCard = styled(Typography).attrs()`
  .custom-card > div {
    box-shadow: ${(props) => props.theme.shadows["10"]};
  }
  .eui-accordion-title {
    width: 100% !important;
  }
`;

export const StyledIcon = styled(Icon).attrs()`
  background: ${(props) => props.theme.palette.primary.c00};
  border-radius: ${(props) => props.theme.borderRadius.tertiary}px;
  padding: 14px;
  height: 52px;
  width: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CustomHover = styled(Typography).attrs()`
  .custom-hover:hover {
    color: ${(props) => props.theme.palette.dark.c300};
  }
`;

export const CustomDropDownHover = styled.div`
  .custom-hover:hover {
    background-color: ${(props) => props.theme.palette.light.c100};
  }
  .custom-hover {
    background-color: transparent;
  }
  .custom-hover:active {
    background-color: ${(props) => props.theme.palette.primary.c01} !important;
  }
  .eui-dd-opt-label {
    display: inline-block;
  }
`;

export const WidthTypography = styled(Typography).attrs()`
  width: 358px !important;
`;
